// Typelizer digest 7a6a96099cf547a24427da2932a9934d
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/bank_syncs/:bank_sync_id/acknowledgement */
  create: (
    params: { bankSyncId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/bank_syncs/:bank_sync_id/acknowledgement', params, options),
    method: 'post',
  }),
}
